
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill",attrs:{"fill":"#141414","d":"M169.49 152.38l-4.06-24.93a21.2 21.2 0 00-13.08-16.29l-10.8-4.31a21.14 21.14 0 01-5.74-3.42l-7.44-6.24a42.73 42.73 0 008.53-10.49 42.51 42.51 0 000-42.63 42.29 42.29 0 00-15.58-15.59 42.53 42.53 0 00-42.64 0A42.29 42.29 0 0063.1 44.07a42.51 42.51 0 000 42.63 42.73 42.73 0 008.53 10.49l-7.44 6.24a21.14 21.14 0 01-5.74 3.42l-10.8 4.31a21.2 21.2 0 00-13.08 16.29l-4.06 24.93A21.21 21.21 0 0051.44 177h97.12a21.21 21.21 0 0020.93-24.62z"}}),_c('path',{staticClass:"filled fill",attrs:{"fill":"#fff","d":"M67.37 65.38a31.64 31.64 0 014.37-16.29 32.28 32.28 0 0112-12 32.55 32.55 0 0132.58 0 32.28 32.28 0 0112 12 32.55 32.55 0 010 32.58 32.2 32.2 0 01-12 12 32.48 32.48 0 01-32.58 0 32.2 32.2 0 01-12-12 31.59 31.59 0 01-4.37-16.29zM157.1 163.05a11 11 0 01-8.54 3.95H51.44a11.21 11.21 0 01-11.06-13l4.06-24.93a11.25 11.25 0 016.91-8.61l10.8-4.31a31.09 31.09 0 008.45-5c2.31-1.92 6-5 9.56-8a42.31 42.31 0 0039.68 0c3.59 3 7.25 6.1 9.56 8a31.09 31.09 0 008.45 5l10.8 4.31a11.25 11.25 0 016.91 8.61l4.06 24.93a11 11 0 01-2.52 9.05z"}})])
          )
        }
      }
    